// Create the Checkout "namespace"
/*global Spinner */
/*global Validation */
var EskimoCheckout = function() {
	/**
	 * SpinJS config
	 */
	var spinJSConfig = {
		lines: 9, // The number of lines to draw
		length: 13, // The length of each line
		width: 3, // The line thickness
		radius: 7, // The radius of the inner circle
		corners: 1, // Corner roundness (0..1)
		rotate: 30, // The rotation offset
		direction: 1, // 1: clockwise, -1: counterclockwise
		color: '#C00', // #rgb or #rrggbb or array of colors
		speed: 1, // Rounds per second
		trail: 45, // Afterglow percentage
		shadow: false, // Whether to render a shadow
		hwaccel: false, // Whether to use hardware acceleration
		className: 'spinner', // The CSS class to assign to the spinner
		zIndex: 2e9, // The z-index (defaults to 2000000000)
		top: 'auto', // Top position relative to parent in px
		left: 'auto' // Left position relative to parent in px
	};

	var spinner = new Spinner(spinJSConfig);

	function getAddressFieldsSelector(address) {
		var fields = {
			title: 'select[name="'+address+'Title"]',
			firstName: 'input[name="'+address+'FirstName"]',
			surname: 'input[name="'+address+'Surname"]',
			houseNumber: 'input[name="'+address+'HouseNumber"]',
			street: 'input[name="'+address+'Street"]',
			address1: 'input[name="'+address+'Street"]',
			address2: 'input[name="'+address+'Address1"]',
			address3: 'input[name="'+address+'Address2"]',
			city: 'input[name="'+address+'City"]',
			county: 'input[name="'+address+'County"]',
			state: 'select[name="'+address+'StateCode"]',
			postCode: 'input[name="'+address+'Postcode"]',
			country: 'select[name="'+address+'Country"]'
		};

		return fields;
	}


	/*
	 * Delivery options
	 */
	function getDeliveryOptions($form) {
		spinner.spin($form[0]);

		$.ajax({
			type: "POST",
			cache: false,
			url: "/js/xhr/getDeliveryOptions.php",
			data: $form.serialize(),
			success: function(response) {
				spinner.stop();

				response = $.parseJSON(response);

				if ( response.success ) {
					if($form.find('.get-delivery-options fieldset select').length > 0) {
						// Remove the existing select
						$form.find('.get-delivery-options fieldset .dk-select').remove();
						$form.find('.get-delivery-options fieldset select').remove();
					}

					$form.find('button[type="submit"]').attr('disabled', false);
					$form.find('.get-delivery-options fieldset').eq(0).append(response.quotes);
					$form.find('.get-delivery-options fieldset select').trigger('change');
					$form.find('.get-delivery-options fieldset select').dropkick({ mobile: true });
					$form.find('.get-delivery-options .error-container span').html( '' );

				} else {
					$form.find('.get-delivery-options fieldset .dk-select').remove();
					$form.find('.get-delivery-options fieldset select').remove();
					$form.find('button[type="submit"]').attr('disabled', true);
					$form.find('.get-delivery-options .error-container span').html( 'Sorry, we couldn\'t find any delivery options.<br/>Please contact the studio for a quotation.' );
				}
			},
			error: function() {
				spinner.stop();
				$form.find('button[type="submit"]').attr('disabled', false);

				alert('Sorry, there was an error processing your request.');
			}
		});
	}

	/*
	 * Confirm the VAT for the order - will be deducted depending on the delivery country
	 */
	function _confirmVATForOrder($form) {
		spinner.spin($form[0]);

		$.ajax({
			type: "POST",
			cache: false,
			url: "/js/xhr/confirmVATForOrder.php",
			data: $form.serialize(),
			success: function(response) {
				spinner.stop();

				response = $.parseJSON(response);

				var $summary = $('.summary');

				$summary.data('total', response.total);
				$summary.find('.vat-charge').html(response.vat);
				$summary.find('.total').html(response.cartTotal);
			},
			error: function() {
				spinner.stop();
				alert('Sorry, there was an error processing your request.');
			}
		});
	}


	/**
	 * Submit order
	 */
	function submitOrder($form) {
		spinner.spin($form[0]);

		$('.checkout-form-errors').html('');
 		$form.find('input').removeClass('error');
        $form.find('button[type="submit"]').attr('disabled', true);
		$form.find('fieldset').removeClass('form-error');

		$('.error-messages ul').html('');
		$('.error-messages').hide();

		$.ajax({
			type: "POST",
			cache: false,
			url: "/xhr/submitAjaxOrder.php",
			data: $form.serialize(),
			success: function(response) {
				spinner.stop();

				try {
                    response = $.parseJSON(response);
                    if(response.error) {
                        $form.find('button[type="submit"]').attr('disabled', false);

						if(response.fields !== undefined) {

							var errorListItems = '',
								hasError = false,
								iError = 0;

							for(iError = 0; iError < response.fields.length; iError++) {

								var error = response.fields[iError];
								if(error.status === false) {
									hasError = true;

									var fieldObj = $form.find('#'+error.field);
									if(fieldObj.length > 0) {
										fieldObj.parent('fieldset').addClass('form-error');

										var message = fieldObj.data('error-title') ;
										if(error.message !== undefined && error.message.length > 0) { message = error.message; }


										if(message !== undefined) {
											errorListItems += '<li class="scroll-to-ele" data-target="'+error.field+'">';
											errorListItems += '<strong>Error:</strong> '+message;
											errorListItems += '</li>';
										}
									}

								}

							}


							if(hasError) {
								$('.error-messages ul').html(errorListItems);
								$('.error-messages').show();

					            $('html, body').animate({
					                scrollTop: $('.error-messages').offset().top - 300
					            }, 200);
							}

						} else {
	                        $('.checkout-form-errors').html(response.error);
	                        $('.step').eq(1).find('a').eq(0).trigger('click');
						}
                    } else {
                        // Redirect the user to SagePay
                        window.location.href = response.url;
                    }
				}
				catch (e) {
					$('.checkout-form-errors').html('An error occurred. Please contact us if you require further assistance.');
		            $form.find('button[type="submit"]').attr('disabled', false);
				}



			},
			error: function() {
				spinner.stop();
				alert('Sorry, there was an error processing your request.');
			}
		});
	}


	function updateMiniCart(data) {

		return $.post( "/js/xhr/cartAction.php", data, function(data) {
		   // Reload Mini Cart...
		   $('.shopping_bag_count').html( data.totalQty );
		   $('#miniCart').html( $(data.contents).html() );
		}, 'json');
	}



	function initializeDropKick() {

		$(".step select").dropkick({
			mobile: true
		});

	}

	function closeMiniCart() {

		$('#miniCart').fadeOut( 300 );

	}


	// return pointers to public methods and properties you want to reveal
	return {
		submitOrder: submitOrder,
		updateMiniCart: updateMiniCart,
		initializeDropKick: initializeDropKick,
		getAddressFieldsSelector: getAddressFieldsSelector,
		getDeliveryOptions: getDeliveryOptions,
		closeMiniCart: closeMiniCart
	};
}();

$(document).ready(function() {

	/*
	 * Checkout
	 */
	// Order submission
	$('.eskimo-checkout form').submit(function(event) {
		event.preventDefault();

		EskimoCheckout.submitOrder($(this));
	});


	if ( $('.qtySelect').length ) {
		$('.qtySelect').dropkick({ mobile: true });
	}


	/*----------------------------------------------------
	Add to basket animation
	------------------------------------------------------*/

	var miniCartTimeout;

	$('.site_top .right a.shopping_bag').on('mouseenter mouseleave touchend',function(e){
		e.preventDefault();

		if ( e.type === 'mouseenter' ) {
			$('#miniCart').fadeIn( 300 );
			clearTimeout( miniCartTimeout );
		} else if ( e.type === 'mouseleave' || e.type === 'touchend' ) {
			miniCartTimeout = setTimeout( "EskimoCheckout.closeMiniCart()" , 3000 );
		}

	});

	$('#miniCart').on( 'mouseenter mouseleave touchend' , function(e) {
		e.preventDefault();

		if ( e.type === 'mouseenter' ) {
			clearTimeout( miniCartTimeout );
		} else if ( e.type === 'mouseleave' || e.type === 'touchend' ) {
			miniCartTimeout = setTimeout( "EskimoCheckout.closeMiniCart()" , 3000 );
		}

	});

	$(document).on('click','.hideCart',function(e){
		e.preventDefault();
		//console.log('clicking close');
		$('#miniCart').fadeOut( 300 );
	});

	/*----------------------------------------------------
	Add to basket functionality
	------------------------------------------------------*/

	$('.addToCartButton:not(.disabled)').click(function(e) {
        // console.log('clicking button');
        e.preventDefault();
        $('form[name="addToCartForm"]').submit();
   	});

   	$('form[name="addToCartForm"] .productOpts').on( 'change' , function(e) {

   		var item = $(this).val();

   		if ( stockLevels[item].stock <= 0 ) {
   			$('form[name="addToCartForm"] input[name="qty"]').prop( 'disabled' , true );
   			$('form[name="addToCartForm"] button[type="submit"]').text('Out of Stock').prop( 'disabled' , true );
   		} else {
   			$('form[name="addToCartForm"] input[name="qty"]').prop( 'disabled' , false );
   			$('form[name="addToCartForm"] button[type="submit"]').text('Add to Bag').prop( 'disabled' , false );
   		}



   	});

  	$('form[name="addToCartForm"]').on( 'submit' , function(e) {

  		e.preventDefault();

  		$('.productOpts').removeClass('error');
  		$('.error_msg').remove();

      	if ( $('select.productOpts').length > 0 ) {
      		if ( $('select.productOpts').val() === '' ) {
      			// alert( 'Please select a product option.' );
      			$('.productChoices').prepend( '<p class="error_msg">Please select a product option below.</p>' );
      			$('select.productOpts').addClass('error');
      			$('select.productOpts').prev().addClass('error');
      			return false;
      		}
      	}

      	$('#miniCart').fadeIn( 300 );
		miniCartTimeout = setTimeout( "EskimoCheckout.closeMiniCart()" , 3000 );

      	EskimoCheckout.updateMiniCart(
         	$(this).serialize()
      	).done(function() {
      	}).fail(function(error) {
         	$('.addToCartButton').addClass('fail');
      	});


   	});

	$(document).on("click", ".miniCartDeleteIcon", function(e) {
		e.stopPropagation();
		EskimoCheckout.updateMiniCart({
			cartAction: "remove",
			itemId: $(this).parent().data('skuid')
		}).fail(function(error) {
			//console.log(error.status, error.statusText);
		});

	});

    $(document).on( 'click' , '.scroll-to-ele' , function(){

        var dataTarget = $(this).data('target'),
            targetObj = $('label[for="'+dataTarget+'"]');

        if(targetObj.length > 0) {
            $('html, body').animate({
                scrollTop: targetObj.offset().top - 300
            }, 200);
        }

    });


	$(document).on( 'change', 'select[name="billingCountry"], select[name="deliveryCountry"]', function() {

		if ( $(this).val() === '235' ) {
			$('.us-state').show();
		} else {
			$('.us-state').hide();
		}

		EskimoCheckout.getDeliveryOptions( $('.checkout-steps') );

	});


	$(document).on( 'change' , '.get-delivery-options fieldset select' , function() {

		if ( $(this).val() !== '0' ) {
			var total = parseFloat( $('.eskimo-checkout .summary').data('subtotal') );
			var shipping = ($(this).val()).split('-');
			var shipping_cost = parseFloat( shipping[0] );

			total += shipping_cost;

			total = total.toFixed(2);
			shipping_cost = shipping_cost.toFixed(2);

			$('.eskimo-checkout .summary .delivery-charge span').html( shipping_cost );
			$('.eskimo-checkout .summary .total span').html( total );

		}

	} );


	$(document).on('change', 'input[name="sameAsBilling"]', function() {

		if ( $(this).prop('checked') ) {

			$('.delivery-address .ship-to-billing').show();

			if($(window).innerWidth() <= 768) {
				$('.delivery-content').css({'max-height': '120px', 'overflow-y' : 'hidden'});
			}

		} else {


			var billingFields  = EskimoCheckout.getAddressFieldsSelector('billing');
			var deliveryFields = EskimoCheckout.getAddressFieldsSelector('delivery');
			$('.delivery-address .ship-to-billing').hide();

			$('.delivery-content').css({'max-height': 'none', 'overflow-y' : ''});

			// Update delivery fields to match the billing fields
			$.each(deliveryFields, function(key, selector) {

				var fieldObj = $(selector),
					billingFieldObj = $(billingFields[key]);

				if(key === 'title' && billingFieldObj.val() !== '0') {
					var dkObj = fieldObj.parent('fieldset').find('.dk-select');
					$(selector).val(billingFieldObj.val());
					dkObj.find('.dk-selected').html(billingFieldObj.val());


					dkObj.find('.dk-select-options li').each(function(){
						$(this).attr('aria-selected', 'false');
						if ($(this).text() === billingFieldObj.val()){
							$(this).attr('aria-selected', 'true');
						}
					});

				}

				if(key === 'firstName' || key === 'surname') {
					$(selector).val($(billingFields[key]).val());
				}
			});


		}

	});

	$(document).on('change', 'input[name="sameAsBillingAccount"]', function() {
		if ( $(this).prop('checked') ) {
			$('.deliveryDetails').hide();
		} else {
			$('.deliveryDetails').show();
		}
	});


	$(document).on( 'submit' , '#create_password' , function(e) {

		e.preventDefault();

		var $form = $(this);
		$form.addClass( 'processing' );

		if(!Validation.validateForm($form)) {
			$form.removeClass( 'processing' );
			return false;
		}

		$.ajax({
			type: "POST",
			cache: false,
			url: "/js/xhr/createAccount.php",
			data: {
				password: $form.find('input[name="password"]').val()
			},
			success: function(response) {
				$form.removeClass( 'processing' );
				$form.html( '<p>' + response + '</p>' );
			},
			error: function() {
				$form.removeClass( 'processing' );
				alert('Sorry, there was a problem setting up your account, please try again.');
			}
		});


	});

	/*----------------------------------------------------
	Basket / checkout
	------------------------------------------------------*/
	$('.updateQty select').on( 'change' , function() {
		$(this).parent().submit();
	});

	if ( $('.step').length ) {
		EskimoCheckout.initializeDropKick();
	}




});